<script>
  import { fade } from 'svelte/transition';
  export let character;
</script>

<style>
  .map img {
    max-width: 100%;
  }
</style>

<div class="map" in:fade>
  {#each character.map as url}
    <img src="{url}" alt="{character.name}">
  {/each}
</div>